interface PriceFieldProps {
  value: string
  onChange: (value: string) => void
  labelWidth?: number
}

const getStyles = (labelWidth: number): Record<string, React.CSSProperties> => ({
  formGroup: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    fontSize: '14px',
    marginBottom: '4px',
    pointerEvents: 'none',
    width: `${labelWidth}px`,
    flexShrink: 0,
    marginRight: '8px',
  },
  inputContainer: {
    flex: 1,
  },
  priceInputContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  priceInput: {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #ddd',
    borderRadius: '4px',
  },
  priceSuffix: {
    marginLeft: '8px',
    fontSize: '16px',
  },
  priceNote: {
    color: '#999',
    fontSize: '10px',
    marginTop: '4px',
  },
})

const PriceField: React.FC<PriceFieldProps> = ({ value, onChange, labelWidth = 80 }) => {
  const styles = getStyles(labelWidth)

  return (
    <div style={styles.formGroup}>
      <label style={styles.label}>
        購入価格
        <br />
        （税込）
      </label>
      <div style={styles.inputContainer}>
        <div style={styles.priceInputContainer}>
          <input
            type="number"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="600"
            style={styles.priceInput}
          />
          <span style={styles.priceSuffix}>円</span>
        </div>
        <div style={styles.priceNote}>
          ※割引で購入したものは割引後の価格を入力
        </div>
      </div>
    </div>
  )
}

export default PriceField
